export function extractErrorReason(networkError) {
  const { errors } = networkError;

  return errors?.[0]?.reason;
}
